/**
 * ExtractionReviewPage - Source extraction review dashboard
 *
 * Surfaces the ExtractionReviewDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides review workflow for LLM extraction confidence verification.
 *
 * Route: /admin/extraction-review
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconEyeCheck } from '@tabler/icons-react';

import { Alert, Stack, Card, Text as MantineText } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useAuth } from '@/auth/AuthContext';

export function ExtractionReviewPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconEyeCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Extraction Review</Title>
            <Text size="sm" c="dimmed">
              Verify and approve LLM extraction results with confidence scoring
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <Alert icon={<IconInfoCircle size={16} />} title="Context Required" color="blue" mb="lg">
        Navigate here from a source map review session to see extraction results.
        Use /admin/source-maps to start a review session.
      </Alert>

      <Stack gap="md">
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <MantineText fw={500} mb="md">Extraction Review Queue</MantineText>
          <MantineText size="sm" c="dimmed">
            No extractions pending review. Upload documents via Intake Studio to populate this queue.
          </MantineText>
        </Card>
      </Stack>
    </Container>
  );
}

export default ExtractionReviewPage;
